import { Component } from '@angular/core';

// servicios
import { InactividadService } from './services/inactividad.service';
import { UsuarioService } from './services/datos/usuario.service';
import { CronTotalesMenuService } from './services/cron-totales-menu.service';

// librerias y entorno
import Swal, { SweetAlertIcon } from 'sweetalert2';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ng_almacen';

  constructor(
    public usuarioSrv: UsuarioService,
    private inactivitySrv: InactividadService,
    private cronTotalesSrv: CronTotalesMenuService,
  ) {
    this.inactivitySrv.onInactivity().subscribe((inactive) => {
      if (inactive) {
        // Se ha detectado inactividad
        console.log('Usuario inactivo. Cerrando sesión...', this.usuarioSrv.userdata.id);
        if (this.usuarioSrv.userdata.id) {
          // Si existe usuario logueado, mostrar aviso
          Swal.fire({
            title: "Tu sesión se ha cerrado por inactividad",
            html: `<b>${this.usuarioSrv.userdata.username}</b> Por seguridad, tu sesión se ha cerrado. <br>Vuelve a identificarte.`,
            icon: "info"
          });
        }

      }
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

}
